var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_310_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7799 10.5802C20.288 10.5802 20.6999 10.1683 20.6999 9.66023C20.6999 9.15213 20.288 8.74023 19.7799 8.74023C19.2718 8.74023 18.8599 9.15213 18.8599 9.66023C18.8599 10.1683 19.2718 10.5802 19.7799 10.5802Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4001 6.89996V0.459961H4.6001V6.89996",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4001 13.3398V22.5398H4.6001V13.3398H18.4001Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59996 18.3999H1.37996C0.872121 18.3999 0.459961 17.9877 0.459961 17.4799V7.8199C0.459961 7.31206 0.872121 6.8999 1.37996 6.8999H21.62C22.1278 6.8999 22.54 7.31206 22.54 7.8199V17.4799C22.54 17.9877 22.1278 18.3999 21.62 18.3999H18.4",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0999 16.1001H6.8999",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2599 17.9399H6.8999",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0999 19.7798H6.8999",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_310_760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.babe7ab567393b6b587d4cfd8fbf56e7.svg";
export { ForwardRef as ReactComponent };